import { selectedKPIsFilter } from "./filters/kpi-filters";
import { sortDiscoveryKPIsByOrder } from "./sorting";

interface DiscoveryKPI {
  kpiCode: string;
  selected: boolean;
  relevant: boolean;
  inScope: boolean;
  order: number;
  importance: number;
  hasImpactValue: boolean;
  hasImpactPercentage: boolean;
  hasFormula: boolean;
  definition: {
    name: string;
    metricMappings?: string[];
    oneTimeBenefit?: boolean;
    status?: string;
    type?: string;
    noFormulaReason?: string;
    formula?: string;
  };
  lowImpactValue?: number | null;
  expectedImpactValue?: number | null;
  potentialImpactValue?: number | null;
}

interface GetKPIsImpactedByMetricsParams {
  discoveryKPI: DiscoveryKPI;
  discoveryKPIs: DiscoveryKPI[];
}

const getKPIsImpactedByMetrics = ({
  discoveryKPI,
  discoveryKPIs
}: GetKPIsImpactedByMetricsParams): DiscoveryKPI[] => {
  const metricMappings = discoveryKPI?.definition?.metricMappings;
  const selectedKPIs = selectedKPIsFilter(discoveryKPIs).filter(
    (kpi) => kpi.kpiCode !== discoveryKPI.kpiCode
  ) as DiscoveryKPI[];

  const kpis = selectedKPIs.filter((kpi) =>
    kpi?.definition?.metricMappings?.some((metric) =>
      metricMappings?.includes(metric)
    )
  );

  kpis.sort(sortDiscoveryKPIsByOrder);

  return kpis;
};

export default getKPIsImpactedByMetrics;
